import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

import Navbar from "./Navbar";
import SwadharmaBand from "./components/SwadharmaBand";
import SamudyogaFooter from "./components/SamudyogaFooter";

import Homepage from "./Homepage";
import JobListings from "./JobListings";
import JobDetails from "./JobDetails";
import JobApplicationForm from "./JobApplicationForm";
import ContactUs from "./Contactus";
import SignIn from "./Signin";
import SignUp from "./Signup";

import AdminDashboard from "./AdminDashboard";
import AdminJobApplication from "./AdminJobApplication";
import AdminApplicationDetails from "./AdminApplicationDetails";
import EditJobForm from "./EditJobForm";
import CandidateDashboard from "./CandidateDashboard";

import Refer from "./Refer";
import Collaborate from "./Collaborate";
import PostJob from "./PostJob";
import SwadharmaApps from "./SwadharmaApps";
import EnrollCandidate from "./EnrollCandidate";
import EnrollCollaborator from "./EnrollCollaborator";
import EnrollReferee from "./EnrollReferee";

const App = () => (
    <Router>
        <div className="App">
            <SwadharmaBand />
            <Navbar />
            <main>
                <Routes>
                    {/* Public landing */}
                    <Route path="/" element={<Homepage />} />

                    {/* Auth */}
                    <Route path="/signin" element={<SignIn />} />
                    <Route path="/signup" element={<SignUp />} />

                    {/* Top-nav intent flows (gated by AuthLink → /signin?next=…) */}
                    <Route path="/job-listings" element={<JobListings />} />
                    <Route path="/post-job"     element={<PostJob />} />
                    <Route path="/refer"        element={<Refer />} />
                    <Route path="/collaborate"  element={<Collaborate />} />
                    <Route path="/contact-us"   element={<ContactUs />} />
                    <Route path="/apps"         element={<SwadharmaApps />} />

                    {/* Enrollment forms */}
                    <Route path="/enroll/candidate"    element={<EnrollCandidate />} />
                    <Route path="/enroll/collaborator" element={<EnrollCollaborator />} />
                    <Route path="/enroll/referee"      element={<EnrollReferee />} />

                    {/* Existing flows */}
                    <Route path="/apply" element={<JobApplicationForm />} />
                    <Route path="/job-details/:id" element={<JobDetails />} />
                    <Route path="/candidate-dashboard" element={<CandidateDashboard />} />

                    {/* Admin */}
                    <Route path="/admin-dashboard" element={<AdminDashboard />} />
                    <Route path="/application/:applicationId" element={<AdminApplicationDetails />} />
                    <Route path="/job/:jobId" element={<AdminJobApplication />} />
                    <Route path="/edit-job/:id" element={<EditJobForm />} />
                </Routes>
            </main>
            <SamudyogaFooter />
        </div>
    </Router>
);

export default App;
